var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":_vm.isMobile ? 'fondo_mobil_mexa' : 'fondoSolo'}},[_c('v-main',{style:(_vm.isMobile ? 'z-index: 24; margin-top:40px;' : 'z-index: 24; margin-top:110px;')},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }